import { EnrichedGeckoInspection } from 'features/inbox/types/types'
import React, { memo, useMemo } from 'react'

interface InspectionCardTitleContentProps {
  inspection: EnrichedGeckoInspection
}

const InspectionCardTitleContentBase: React.FC<
  InspectionCardTitleContentProps
> = ({ inspection }) => {
  const title = useMemo(() => {
    const unitName = inspection.data?.unitName as string
    const componentName = inspection.data?.componentName as string
    const inspectionName = inspection.data?.name as string

    if (unitName && componentName) {
      return `${unitName}: ${componentName}`
    } else if (unitName) {
      return unitName
    } else if (componentName) {
      return componentName
    } else if (inspectionName) {
      return inspectionName
    } else {
      return inspection.id
    }
  }, [inspection])

  return <>{title}</>
}

export const InspectionCardTitleContent = memo(InspectionCardTitleContentBase)
